<template>
    <div id="index" v-observe:once="callback">
        <!-- 轮播图容器 -->
        <div class="carousel-container"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"    
        >
            <!-- 轮播图轨道 -->
            <div 
                class="carousel-track" 
                :style="{ transform: `translateX(-${currentIndex * 100}%)`, transition: transitionStyle }"
            >
                <!-- 轮播项 -->
                <div 
                    v-for="(slide, index) in displaySlides" 
                    :key="index" 
                    class="carousel-item"
                    :style="{ backgroundImage: `url(${slide.image})` }"
                    loading="eager"
                >
                    <!-- 每张轮播图上的内容 -->
                    <div class="container"   
                        :style="{
                            top: slide.position.top,
                            left: slide.position.left
                        }">
                        <div class="container-1 animated-text" :style="{ animationDelay: `${0.2 + (index * 0.1)}s` }" >
                            {{ slide.title }}
                        </div>
                        <div class="container-2 animated-text" :style="{ animationDelay: `${0.4 + (index * 0.1)}s` }">
                            {{ slide.subtitle }}
                        </div>
                        <div class="container-3 animated-text" v-show="slide.buttonText != ''" :style="{ animationDelay: `${0.6 + (index * 0.1)}s` }">
                            <button class="container-3-btn" @click="navigateToPath(slide.path)">
                                <span class="button-content">{{ slide.buttonText }}<img src='@/assets/Image.png' class="container-3-btn-image"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 轮播指示器 (注意：指示器只对应真实数据，所以需要映射索引) -->
            <div class="carousel-indicators">
                <span 
                    v-for="(slide, index) in carouselSlides" 
                    :key="`indicator-${index}`"
                    :class="['indicator', { active: getRealIndex(index) === getRealIndex(currentIndex) }]"
                    @click="goToSlide(index)"
                ></span>
            </div>
            
            <!-- 左右导航按钮 -->
            <button class="nav-btn prev-btn" @click="prevSlide">‹</button>
            <button class="nav-btn next-btn" @click="nextSlide">›</button>
        </div>
    </div>
</template>

<script>
import {getBannerList} from '@/api/banner.js'
export default {
    name: 'index',
    data() {
        return {
            currentIndex: 1, // 初始为1，因为0是克隆的最后一张
            transitionStyle: 'transform 0.5s ease-in-out', // 控制过渡效果
            carouselSlides: [], // 真实数据
            autoplayTimer: null
        }
    },
    computed: {
        // 生成包含克隆节点的显示数组
        displaySlides() {
            if (this.carouselSlides.length === 0) return [];
            const first = this.carouselSlides[0];
            const last = this.carouselSlides[this.carouselSlides.length - 1];
            return [last, ...this.carouselSlides, first];
        }
    },
    mounted() {
        this.fetchBannerData();
    },
    beforeDestroy() {
        this.stopAutoplay();
    },
    methods: {
        handleMouseEnter() {
            this.stopAutoplay();
        },
        handleMouseLeave() {
            this.startAutoplay();
        },
        
        async fetchBannerData() {
            try {
                const response = await getBannerList();
                if (response && response.data) {
                    this.carouselSlides = response.data.map((item) => {
                        let position, path, buttonText;
                        if (item.bnIndex === 1) {
                            position = { top: '240px', left: '50%' };
                            path = '/FlyingPlatform';
                            buttonText = '';
                        } else if (item.bnIndex === 2) {
                            position = { top: '50%', left: '50%' };
                            path = '/about';
                            buttonText = '了解更多';
                        } else {
                            position = { top: '50%', left: '50%' };
                            path = '#';
                            buttonText = '';
                        }
                        return {
                            image: item.bnImage+ '?x-oss-process=image/resize,w_1920/format,webp/quality,Q_80',
                            title: item.bnTitle,
                            subtitle: item.bnSubtitle,
                            path: path,
                            position: position,
                            buttonText: buttonText
                        };
                    });
                    
                    // 数据加载完成后，重置索引并启动自动播放
                    this.currentIndex = 1;
                    this.stopAutoplay();
                    this.startAutoplay();            
                }
            } catch (error) {
                console.error('获取轮播图数据失败:', error);
            }
        },

        callback(element, entry) {
            element.classList.add('animate-in');
        },

        navigateToPath(path) {
            if (path) {
                this.$router.push(path);
            }
        },

        // 获取真实数据的索引（用于指示器高亮）
        getRealIndex(displayIndex) {
            if (this.carouselSlides.length === 0) return 0;
            // 如果是第一个克隆项（索引0），对应真实最后一项
            if (displayIndex === 0) return this.carouselSlides.length - 1;
            // 如果是最后一个克隆项（索引length+1），对应真实第一项
            if (displayIndex === this.displaySlides.length - 1) return 0;
            // 其他情况减1即为真实索引
            return displayIndex - 1;
        },

        // 下一张
        nextSlide() {
            if (this.carouselSlides.length === 0) return;
            
            this.transitionStyle = 'transform 0.5s ease-in-out'; // 开启过渡
            this.currentIndex++;

            // 如果到了最后一个克隆项（即视觉上的第一张）
            if (this.currentIndex === this.displaySlides.length - 1) {
                // 等待过渡动画结束（500ms），然后瞬间切换回真实的第一个
                setTimeout(() => {
                    this.transitionStyle = 'none'; // 关闭过渡
                    this.currentIndex = 1; // 跳回真实的第一张
                }, 500);
            }
        },

        // 上一张
        prevSlide() {
            if (this.carouselSlides.length === 0) return;

            this.transitionStyle = 'transform 0.5s ease-in-out'; // 开启过渡
            this.currentIndex--;

            // 如果到了第一个克隆项（即视觉上的最后一张）
            if (this.currentIndex === 0) {
                // 等待过渡动画结束，然后瞬间切换回真实的最后一个
                setTimeout(() => {
                    this.transitionStyle = 'none'; // 关闭过渡
                    this.currentIndex = this.carouselSlides.length; // 跳回真实的最后一张
                }, 500);
            }
        },

        // 跳转到指定图片
        goToSlide(index) {
            // index 是真实数据的索引 (0, 1, 2...)
            // 对应的 displaySlides 索引是 index + 1
            this.transitionStyle = 'transform 0.5s ease-in-out';
            this.currentIndex = index + 1;
        },

        startAutoplay() {

            this.autoplayTimer = setInterval(() => {
                this.nextSlide();
            }, 5000);
        },

        stopAutoplay() {
            if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
                this.autoplayTimer = null;
            }
        }
    },
}
</script>

<style scoped>
#index {
    width: 1920px;
    height: 970px;
    overflow: hidden;
    position: relative;
    opacity: 0;
    transform: translateY(50px); /* 初始位置在下方 */
    transition: all 1s ease; /* 添加过渡效果 */

}
#index.animate-in{
    opacity: 1;
    transform: translateY(0);
}
/* 轮播图容器 */
.carousel-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

/* 轮播轨道 */
.carousel-track {
    display: flex;
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease-in-out;
}

/* 轮播项 */
.carousel-item {
    min-width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
}

.container {
    position: absolute;
    display: flex;
    width: 36.41vw;
    flex-direction: column;
    height: auto;
    gap: 8px;
    opacity: 1;
    align-items: center;
    justify-content: center;
    top: 192px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.container-1 {
    width: 36.41vw;
    font-family: Microsoft YaHei;
    font-weight: 600;
    font-style: Semibold;
    font-size: 40px;
    leading-trim: NONE;
    line-height: 48px;
    letter-spacing: 5.12px;
    vertical-align: middle;
    text-align: center;
    color: #FFFFFF;
}

.container-2 {
    /* width: 36.41vw; */
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 48px;
    letter-spacing: 5.12px;
    vertical-align: middle;
    white-space: nowrap;
    color: #FFFFFF;
}

.container-3-btn {
    width: 158px;
    height: 44px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #000000;
    border: 0;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 2.56px;
    position: relative;
    overflow: hidden;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.container-3-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background: #3985e7ff; /* 蓝色背景 */
    transition: width 0.3s ease;
    z-index: -1;
}

.button-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 100%;
    width: 100%;
}

.container-3-btn:hover::before {
    width: 100%;
}

.container-3-btn:hover img {
    content: url('@/assets/image2.png'); /* 悬停时显示 Image2 */
}

.container-3-btn:hover {
    color: #FFFFFF; 
    cursor: pointer;
}

/* 指示器 */
.carousel-indicators {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
}

.indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.indicator.active {
    background-color: white;
}

/* 导航按钮 */
.nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    font-size: 24px;
    color: white;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.3s ease;
    z-index: 10;
}

.nav-btn:hover {
    background-color: rgba(255, 255, 255, 0.5);
}

.prev-btn {
    left: 200px;
}

.next-btn {
    right: 200px;
}

.container-3-btn img {
    width: 16px;
    height: 16px;
    transition: transform 0.3s ease; /* 箭头悬停效果 */
}
.animated-text {
    opacity: 0;
    transform: translateY(20px);
    animation: slideInUp 0.8s ease forwards;
    animation-delay: 0.2s; /* 文字比图片晚0.2秒出现 */
}

@keyframes slideInUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* 确保这些元素在动画开始前不可见 */
#index .container > div {
    opacity: 0;
}
</style>

<style>
body {
    margin: 0;
    padding: 0;
    overflow-y: auto;
}
</style>